import { Head, Link } from "@inertiajs/react";
import { PageProps } from "@/types";
import ApplicationLogo from "@/Components/ApplicationLogo";
import { Button } from "@/Components/ui/button";
import { ArrowRight, MessageCircle } from "lucide-react";
import Favicon from "@/Components/Favicon";

export default function Welcome({ auth }: PageProps) {
    return (
        <>
            <Favicon />
            <Head title="Welcome" />

            <div className="min-h-screen overflow-hidden relative flex items-center justify-center">
                {/* Background Effects */}
                <div className="absolute inset-0 w-full h-full">
                    {/* Gradient Mesh */}
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 via-transparent to-purple-500/20" />
                    
                    {/* Animated Circles */}
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-[pulse_8s_ease-in-out_infinite]" />
                    <div className="absolute bottom-1/4 right-1/3 w-64 h-64 bg-purple-500/20 rounded-full blur-3xl animate-[pulse_8s_ease-in-out_infinite_7s]" />
                    <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-indigo-500/20 rounded-full blur-3xl animate-[pulse_8s_ease-in-out_infinite_3s]" />
                </div>

                {/* Content */}
                <div className="w-full max-w-lg mx-auto p-6 text-center space-y-8 relative z-10">
                    {/* Logo */}
                    <ApplicationLogo className="h-16 w-auto mx-auto" />

                    {/* Content */}
                    <div className="space-y-4">
                        <h1 className="text-3xl font-bold text-white">
                            Welcome to NOVA Agency
                        </h1>
                        <p className="text-white/70">
                            Your platform for managing ad accounts and digital marketing campaigns
                        </p>
                    </div>

                    {/* Actions */}
                    <div className="space-y-4">
                        {auth.user ? (
                            <Button asChild size="lg" className="w-full">
                                <Link href={route("dashboard")}>
                                    Go to Dashboard
                                    <ArrowRight className="ml-2 h-4 w-4" />
                                </Link>
                            </Button>
                        ) : (
                            <>
                                <Button asChild size="lg" className="w-full">
                                    <Link href={route("login")}>
                                        Login to Your Account
                                        <ArrowRight className="ml-2 h-4 w-4" />
                                    </Link>
                                </Button>
                                <Button
                                    asChild
                                    size="lg"
                                    variant="outline"
                                    className="w-full bg-[#25D366] hover:bg-[#128C7E] text-white border-[#25D366] hover:border-[#128C7E]"
                                >
                                    <a 
                                        href="https://wa.me/31627210591"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center justify-center"
                                    >
                                        <MessageCircle className="mr-2 h-4 w-4" />
                                        Contact us for onboarding
                                    </a>
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
